import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import * as S from './styled';
//hooks
import apiRequest from '../../../../hooks/apiRequest';
import useLoading from '../../../../hooks/useLoading';
//Components
import LayoutModal from '../../../LayoutModal';
//Interfaces
import { Inputs } from 'Interfaces/ICard';
import { ICreate } from 'Interfaces/ICreate';

export default function CreateCard({
  isOpenModal,
  setModalClose,
  refreshFrames,
  setToastData,
  setToastOpen
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const response = await apiRequest('card', 'POST', data);
      if (response.status === 201) {
        setToastData({
          status: response.status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        onClose();

      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  }

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Registrar Taxa do Cartão"
        subTitle="Cadastre uma nova taxa em sua base de dados."
        setModalClose={onClose}
        submiteModal={handleFormSubmit(onSubmit)}

        nameIconMinimize={'Registrar Fornecedor'}
      >
        <S.Container>
          <S.FormInput>
            <S.Label>
              Parcelas
              <span>*</span>
            </S.Label>
            <S.Input
              placeholder="Número de parcelas"
              type="number"
              {...register("number_installment", { required: true })}
            />
            {errors.number_installment && <S.InforErro>Campo Obrigatório</S.InforErro>}
          </S.FormInput>

          <S.FormInput>
            <S.Label>Taxa (%)</S.Label>
            <Controller
              name="interest_rate"
              control={control}
              render={({ field: { onChange, value, ref } }) => (
                <NumericFormat
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale={true}
                  placeholder="0,00 %"
                  suffix=" %"
                  value={value}
                  onValueChange={(values) => {
                    const purchaseValue = values.floatValue ?? 0;
                    onChange(purchaseValue); // Atualiza o valor de compra
                  }}
                  getInputRef={ref}
                />
              )}
            />
          </S.FormInput>
        </S.Container>
      </LayoutModal>
    );
  }
  return null;
}